// extracted by mini-css-extract-plugin
export default {"qrBox":"styles_qrBox__XHezL"};